export default `@media (min-width: 320px) {
  :host .xs-header {
    display: flex;
    position: absolute;
  }
  :host .xs-header .label {
    margin-left: var(--ids-space-2xs);
  }
}
@media (min-width: 927px) {
  :host .xs-header {
    display: none;
    position: unset;
  }
}

.ids-process-indicator {
  width: 100%;
  height: auto;
}
.ids-process-indicator .step-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtcHJvY2Vzcy1pbmRpY2F0b3IiLCJzb3VyY2VzIjpbImlkcy1wcm9jZXNzLWluZGljYXRvci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdFO0VBQ0U7SUFDRTtJQUNBOztFQUVBO0lBQ0U7OztBQUtOO0VBQ0U7SUFDRTtJQUNBOzs7O0FBS047RUFDRTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiQHVzZSAnLi4vLi4vdGhlbWVzL21peGlucy9pZHMtY29yZS1taXhpbnMnIGFzICo7XG5cbjpob3N0IHtcbiAgQG1lZGlhIChtaW4td2lkdGg6ICRicmVha3BvaW50LXhzKSB7XG4gICAgLnhzLWhlYWRlciB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuXG4gICAgICAubGFiZWwge1xuICAgICAgICBtYXJnaW4tbGVmdDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgQG1lZGlhIChtaW4td2lkdGg6ICRicmVha3BvaW50LW1kKSB7XG4gICAgLnhzLWhlYWRlciB7XG4gICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgcG9zaXRpb246IHVuc2V0O1xuICAgIH1cbiAgfVxufVxuXG4uaWRzLXByb2Nlc3MtaW5kaWNhdG9yIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogYXV0bztcblxuICAuc3RlcC1jb250YWluZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbn1cbiJdfQ== */`;
